import HightlightTextAni from '../HighlightTextAni';
import { useLang } from '@/i18n';

const E: React.FC = () => {
    const { t } = useLang('dpux');
    return <HightlightTextAni id={'delta-pro-ultra-x-E'} title={t('E_title')} desc={t('E_desc')} />;
};

export default E;
